import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import type { ValidationLogsInput } from '../../models/validation-logs';
import { UploadFilesService } from '../../services/upload-files.service';

@Component({
  selector: 'app-field-mapping-step',
  templateUrl: './field-mapping-step.component.html',
  styleUrls: ['./field-mapping-step.component.scss'],
})
export class FieldMappingStepComponent {
  @Input() form!: FormGroup;
  @Input() fields: any[] = [];
  @Input() fileOptions: string[] = [];
  @Input() columnOptionsByFile: Record<string, string[]> = {};
  @Input() validationLogs: ValidationLogsInput = '';
  @Input() isLoading: boolean = false;
  @Input() isProcessing: boolean = false;
  @Input() isPublishing: boolean = false;
  @Input() filesValidated: boolean = false;

  @Output() saveAndValidateMapping = new EventEmitter<void>();
  @Output() process = new EventEmitter<void>();
  @Output() export = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  constructor(public uploadFilesService: UploadFilesService) {}

  getColumnOptions(index: number): string[] {
    const selectedFile = this.form.get(['mappings', index, 'file'])?.value;

    return selectedFile ? (this.columnOptionsByFile[selectedFile] ?? []) : [];
  }

  hasSelectedFile(index: number): boolean {
    return !!this.form.get(['mappings', index, 'file'])?.value;
  }

  onFileChange(index: number): void {
    const columnControl = this.form.get(['mappings', index, 'column']);
    const selectedColumn = columnControl?.value;

    if (selectedColumn && !this.getColumnOptions(index).includes(selectedColumn)) {
      columnControl?.setValue(null);
    }
  }
}
